// role-based-dashboards — Phase 5.2: super_admin platform overview route.
//
// Access: super_admin only. The _authenticated.super-admin.tsx layout
// already redirects non-super_admin roles to /dashboard, so no additional
// gate is needed here (mirrors _authenticated.super-admin.audit-log.index.tsx).
//
// NOTE: .index.tsx suffix REQUIRED per TanStack Router file-based routing convention.

import { createFileRoute } from '@tanstack/react-router';

import { PlatformOverviewPage } from '../modules/super-admin-overview/ui/pages/PlatformOverviewPage';

export const Route = createFileRoute('/_authenticated/super-admin/overview/')({
  component: PlatformOverviewPage,
  staticData: {
    breadcrumb: ['Platform', 'Overview'],
  },
});
